import React from 'react';
import { XMarkIcon } from '@heroicons/react/20/solid';

// A bar with the sums of a selection: a title ("3 nights selected"), a list of named values and a button that clears
// the selection. It sits above the list that the user selects in (a table of nights). The values are already formatted
// by the caller. On a narrow screen the values wrap to more lines; the button stays at the end.
export type SelectionBarItem = {
	id: string,
	label: string,
	value: string,
};

type Props = {
	title: string,
	items: SelectionBarItem[],
	onClear: () => void,
	clearLabel?: string,
};

const SelectionBar: React.FunctionComponent<Props> = ({ title, items, onClear, clearLabel = 'Clear' }) =>
	<div role="status" aria-live="polite" className="flex flex-wrap items-center gap-x-6 gap-y-2 rounded-lg bg-blue-600 px-4 py-3 text-sm text-white shadow-sm">
		<span className="font-semibold">{title}</span>
		{items.map(item => <span key={item.id} className="whitespace-nowrap">{item.label} <span className="font-semibold">{item.value}</span></span>)}
		<button type="button" onClick={onClear}
			className="ml-auto inline-flex items-center gap-x-1 rounded-md bg-white/10 px-2 py-1 text-xs font-semibold ring-1 ring-inset ring-white/30 hover:bg-white/20 focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white">
			<XMarkIcon aria-hidden="true" className="h-4 w-4" />{clearLabel}
		</button>
	</div>;

export default SelectionBar;
